import * as RadixTooltip from '@radix-ui/react-tooltip';
import styled, { keyframes } from 'styled-components';

import { size } from '../../layout/helpers';

const slideUpAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideDownAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideLeftAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateX(2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideRightAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateX(-2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

interface TooltipContentProps {
  $whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-wrap';
}

export const TooltipContent = styled(RadixTooltip.Content)<TooltipContentProps>`
  padding: ${size(0.25)} ${size(0.75)};
  background-color: var(--c-contrast-bg);
  color: var(--c-contrast-fg);
  font-size: ${(props) => props.theme.font.size.xsmall};
  border-radius: var(--border-radius);
  white-space: ${({ $whiteSpace }) => $whiteSpace || 'nowrap'};
  z-index: 9999;
  animation-duration: 150ms;
  animation-timing-function: ease-out;
  will-change: transform, opacity;

  &[data-state='delayed-open'][data-side='top'] {
    animation-name: ${slideUpAndFade};
  }

  &[data-state='delayed-open'][data-side='bottom'] {
    animation-name: ${slideDownAndFade};
  }

  &[data-state='delayed-open'][data-side='left'] {
    animation-name: ${slideLeftAndFade};
  }

  &[data-state='delayed-open'][data-side='right'] {
    animation-name: ${slideRightAndFade};
  }
`;

export const TooltipArrow = styled(RadixTooltip.Arrow)`
  fill: var(--c-contrast-bg);
`;

export const TooltipTrigger = styled.span.attrs({ tabIndex: 0 })`
  display: inline;
`;
